"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarNote = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 12;

function CalendarNote(_a) {
  var children = _a.children,
      fill = _a.fill,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      props = tslib_1.__rest(_a, ["children", "fill", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: size,
    height: size,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6924 2.69922H16.6924C17.797 2.69922 18.6924 3.59465 18.6924 4.69922V17.6992C18.6924 18.8038 17.797 19.6992 16.6924 19.6992H2.69238C1.58781 19.6992 0.692383 18.8038 0.692383 17.6992V4.69922C0.692383 3.59465 1.58781 2.69922 2.69238 2.69922H3.69238V1.19922C3.69238 0.923076 3.91624 0.699219 4.19238 0.699219H5.19238C5.46853 0.699219 5.69238 0.923076 5.69238 1.19922V2.69922H13.6924V1.19922C13.6924 0.923076 13.9162 0.699219 14.1924 0.699219H15.1924C15.4685 0.699219 15.6924 0.923076 15.6924 1.19922V2.69922ZM2.69238 17.6992H16.6924V6.69922H2.69238V17.6992ZM5.19238 14.6992H10.1924C10.4685 14.6992 10.6924 14.4754 10.6924 14.1992V13.1992C10.6924 12.9231 10.4685 12.6992 10.1924 12.6992H5.19238C4.91624 12.6992 4.69238 12.9231 4.69238 13.1992V14.1992C4.69238 14.4754 4.91624 14.6992 5.19238 14.6992ZM14.1924 10.6992H5.19238C4.91624 10.6992 4.69238 10.4754 4.69238 10.1992V9.19922C4.69238 8.92308 4.91624 8.69922 5.19238 8.69922H14.1924C14.4685 8.69922 14.6924 8.92308 14.6924 9.19922V10.1992C14.6924 10.4754 14.4685 10.6992 14.1924 10.6992Z",
    fill: fill
  }));
}

exports.CalendarNote = CalendarNote;